<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('duihuang.title')}}</div>
        </div>
        <div class="cont-box">
            <!-- <div class="title">{{this.$t('duihuang.hl')}} 1 {{from_bz}} ≈ {{curCurrency}} {{to_bz}}</div> -->
            <div class="item-box">
                <div class="item-head">
                    <div class="t1">{{this.$t('duihuang.zf')}}</div>
                    <!-- <div class="t2" @click="allChange">{{this.$t('duihuang.qbdh')}}</div> -->
                </div>
                <div class="item-head item-foot">
                    <div class="t3"><input class="input" type="number" min="0" v-model="money" @keyup="keyMoney()" :placeholder="$t('xbsg.qsrsl')" autocomplete="off"></div>
                    <div class="t4 from-bz" @click="show(1,from_bz)">{{from_bz}}</div>
                </div>
            </div>
            <!-- <div class="img-box"><img class="img" src="@/assets/Conversion.png" @click="change(from_bz,to_bz,from_type,to_type)" alt=""></div> -->
            <div class="item-box item-box2">
                <div class="item-head">
                    <div class="t1">{{this.$t('duihuang.dd')}}</div>
                </div>
                <div class="item-head item-foot">
                    <div class="t3"></div>
                    <div class="t4">{{to_bz}}</div>
                </div>
            </div>
            <button class="btn" type="button" @click="duiHuang">{{this.$t('duihuang.ljdh')}}</button>
        </div>
        <div class="mask" v-show="isMask" @click="cancle"></div>
        <div class="alert-wrap" v-show="isShow">
            <ul class="alert-box">
                <li class="alert-li" v-for="(item,index) in currencyAll" :key="index" @click="select(item.name)">
                    <img class="icon" :src="item.icon" alt="">
                    <div class="text">{{item.name}}</div>
                    <!-- <div class="money"></div> -->
                </li>
            </ul>
            <!-- <div class="alert-btn" @click="cancle">{{this.$t('duihuang.qx')}}</div> -->
        </div>
        <!-- 审核失败 -->
        <div class="alert-wrap2" v-show="isShow2">
            <div class="alert-head">
                {{this.$t('duihuang.ts')}}
                <img class="icon" src="@/assets/close.png" @click="close" alt="">
            </div>
            <div class="cont">{{btcmTips}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'duihuang',
    data () {
        return {
            isShow: false,
            isShow2: false,
            isMask: false,
            isPay: false,
            uid: '',
            token: '',
            btcm: 1.5,
            usdt: 1,
            btc: '',
            eth: '',
            trx: '',
            curBz: '',
            curMoney: '',
            btc_money: '',
            btcm_money: '',
            usdt_money: '',
            eth_money: '',
            trx_money: '0.0000',
            money: '',
            ddMoney: '',
            fx: 1,
            from_bz: 'ETH',
            from_type: 1,
            to_type: 2,
            to_bz: 'USDT',
            curCurrency: 0,
            timer: null,
            btcmTips: '',
            inputList: [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}],
            currencyAll: []
        }
    },
    mounted(){
        this.token =localStorage.getItem('token');
        this.getCurrencyAll();
    },
    methods: {
      getCurrencyAll(){//所有币种
        this.$ajax.post('/web/getCurrencyAll').then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            this.currencyAll = resData;
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      duiHuang(){
        let params = {
          amount: this.money,
          price_type: 1,
          mark: 2,
          currency: this.from_bz,
          deal_type: 1,
        }
          if(this.money == '' || this.money == null){
              this.$toast.center(this.$t('duihuang.qtxje'));
              return;
          }else if(this.money <= 0){
              this.$toast.center(this.$t('pay.kyyebz'));
              return;
          }
          this.$ajax.post('/web/createOrder',params).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 0){
              this.$toast.center(this.$t('status.statusText')[2]);
              this.$router.push('/index');
            }else{
              this.$router.push('/index');
            }
          }).catch(function(err){
              console.log(err)
          })
      },
      show(fx,bz){
          this.isMask = true;
          this.isShow = true;
          this.fx = fx;
          if(fx == 1){
              this.curBz = this.to_bz;
              if(bz == 'BTC'){
                  this.curMoney = this.btc_money;
              }else if(bz == 'ETH'){
                  this.curMoney = this.eth_money;
              }else if(bz == 'USDT'){
                  this.curMoney = this.usdt_money;
              }else if(bz == 'TRX'){
                  this.curMoney = this.trx_money;
              }else{
                  this.curMoney = this.usdt_money;
              }
          }else{
              this.curBz = this.from_bz;
          }
      },
      select(bz,type,money,currency){
          if(this.fx == 1){
              this.money = '';
              this.from_bz = bz;
              this.from_type = type;
              this.curMoney = money;
          }else{
              this.to_bz = bz;
              this.to_type = type;
          }
          // this.money = '';
          this.isShow = false;
          this.isMask = false;
      },
        keyMoney(){
          this.money = this.money.replace(/[^\d.]/g, "");  //仅保留数字和"."
          this.money = this.money.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this.money = this.money.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          this.money = this.money.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (this.money.indexOf(".") < 0 && this.money != "") { //首位是0的话去掉
            this.money = parseFloat(this.money);
          }
        },
        allChange(){
           if(this.from_bz == 'BTC'){
                this.money = this.btc_money;
            }else if(this.from_bz == 'ETH'){
                this.money = this.eth_money;
            }else if(this.from_bz == 'USDT'){
                this.money = this.usdt_money;
            }else if(this.from_bz == 'TRX'){
                this.money = this.trx_money;
            }else{
                 this.money = this.usdt_money;
            }
            this.ddMoney = (this.money * this.curCurrency).toFixed(4);
        },
        change(from,to,from_type,to_type){
            this.from_bz = to;
            this.to_bz = from;
            this.from_type = to_type;
            this.to_type = from_type;
            this.ddMoney = (this.money * this.curCurrency).toFixed(4);
            this.currency();
        },
        cancle(){
            this.isShow = false;
            this.isShow3 = false;
            this.isMask = false;
            this.isPay = false;
        },
        close(){
            this.isShow2 = false;
            this.isShow3 = false;
            this.isMask = false;
        },
        goBack(){
            this.$router.push('/index');
        },
    },
    filters: {
        toFixed4: function(val){
            if(val){
                return val.toFixed(4)
            }else{
                return '0.0000'
            }
        }
    },
    beforeDestroy(){
        clearInterval(this.timer);
        this.timer = null;
    },
    watch: {
        money: function(val){
            if(val > parseFloat(this.curMoney)){
                this.money = this.curMoney
            }else{
                this.money = val;
            }
            this.ddMoney = (val * this.curCurrency).toFixed(4);
        }
    }
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #ababab;
        font-size: .36rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .32rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .cont-box{
        position: absolute;
        left: 0;
        top: 1.2rem;
        bottom: 0;
        width: 100%;
        height: auto;
        padding: 0 .24rem;
        /* background: #0E1530; */
        box-sizing: border-box;
        overflow-y: auto;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        /* background: #0E1530; */
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .32rem;
        height: .6rem;
        transform: translateY(-50%);
    }
    .title{
        padding: .48rem 0;
        color: #ababab;
        font-size: .48rem;
    }
    .item-box{
        margin-bottom: .28rem;
        padding: .28rem .2rem .6rem .28rem;
        background: rgb(4 ,9 ,37,.5);
        border-radius: .1rem;
    }
    .item-box .item-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .item-box .item-foot{
        padding-top: .4rem;
    }
    .item-box .t1{
        color: #fff;
        font-size: .42rem;
    }
    .item-box .t2{
        color: #43D0CB;
        font-size: .48rem;
    }
    .item-box .t3,.item-box .t3 .input{
        width: 100%;
        color: #ababab;
        font-size: .48rem;
        background: transparent;
    }
    .item-box .t4{
        position: relative;
        color: #fff;
        font-size: .48rem;
    }
    .item-box .from-bz{
        padding: 0 .34rem;
        text-transform: uppercase;
    }
    .item-box .from-bz::after{
        position: absolute;
        right: 0;
        top: 50%;
        content: '';
        width: 0;
        height: 0;
        margin-top: -.03rem;
        border-top: .12rem solid #fff;
        border-left: .12rem solid transparent;
        border-right: .12rem solid transparent;
    }
    .item-box2{
        margin-top: .3rem;
    }
    .img-box{
        position: relative;
        top: -.56rem;
        text-align: center;
    }
    .img-box .img{
        width: .72rem;
        height: .72rem;
    }
    .btn{
        width: 100%;
        height: 1.2rem;
        margin-top: .8rem;
        color: #fff;
        font-size: .48rem;
        line-height: 1.2rem;
        background: linear-gradient(267deg,rgba(44, 170, 222, 0.5), rgba(93, 205, 233, 0.5));
        border-radius: .2rem;
        text-align: center;
    }
    /* .tips{
        padding-top: .32rem;
        color: #ababab;
        font-size: .24rem;
        text-align: center;
    } */
    .tips{
        padding: .5rem 0 .4rem;
        color: #ababab;
        font-size: .36rem;
    }
    .tips-text{
        padding: 0 0 .2rem;
        color: #ababab;
        font-size: .32rem;
    }
    .alert-wrap{
        position: fixed;
        bottom: 0;
        z-index: 1000;
        width: 100%;
        height: 8rem;
        border-radius: .2rem .2rem 0 0;
        background: #1A243F;
        overflow-y: scroll;
    }
    .alert-wrap .alert-box{
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
    }
    .alert-wrap .alert-box .alert-li{
        display: flex;
        align-items: center;
        width: 100%;
        height: 1.4rem;
        padding: 0 .44rem;
        color: #fff;
        font-size: .52rem;
        line-height: 1.4rem;
        border-bottom: 1px solid #858585;
        box-sizing: border-box;
    }
    .alert-wrap .alert-box .alert-li:last-child{
        /* border-bottom: none; */
    }
    .alert-wrap .alert-box .alert-li .text{
      text-transform: uppercase;
    }
    .alert-wrap .alert-box .alert-li .money{
        flex: 1;
        text-align: right;
    }
    .alert-wrap .alert-box .icon{
        margin-right: .38rem;
        width: .78rem;
        height: .78rem;
    }
    .alert-wrap .alert-btn{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 2rem;
        color: #fff;
        font-size: .48rem;
        line-height: 2rem;
        border-top: 2px solid #3A4560;
        background: #1A243F;
        text-align: center;
    }
    .alert-wrap2{
        position: absolute;
        left: 1rem;
        right: 1rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .42rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .42rem;
        top: .42rem;
        width: .42rem;
        height: .42rem;
    }
    .alert-wrap2 .cont{
        max-height: 6rem;
        padding: 0 .4rem .72rem .36rem;
        color: #fff;
        font-size: .48rem;
        overflow: auto;
    }
    .pwd-alert-box{
        position: absolute;
        left: .92rem;
        right: .95rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        padding: .26rem .46rem .68rem .46rem;
        background: rgba(55, 76 ,124,.9);
        border-radius: .07rem;
        box-sizing: border-box;
        transform: translateY(-50%);
    }
    .pwd-alert-box .alert-head{
        position: relative;
        color: #fff;
        font-size: .48rem;
        text-align: center;
    }
    .pwd-alert-box .close{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .32rem;
        height: .32rem;
    }
    .pwd-alert-box .pwd-box{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: .5rem;
        border: 1px solid #fff;
    }
    .pwd-alert-box .pwd-box .pwd{
        flex: 1;
        height: .88rem;
    }
    .pwd-alert-box .pwd-box .pwd .input{
        width: 100%;
        height: .88rem;
        color: #fff;
        font-size: .42rem;
        border-right: 1px solid #fff;
        background: #374C7C;
        text-align: center;
        box-sizing: border-box;
        border-radius: 0;
        font-weight: bold;
        outline: none;
    }
    .pwd-alert-box .pwd-box .pwd:last-child .input{
        border-right: none;
    }
    .alert-pay{
        position: absolute;
        left: 1.3rem;
        right: 1.18rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-pay .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .42rem;
        text-align: center;
    }
    .alert-pay .alert-head .icon{
        position: absolute;
        right: .42rem;
        top: .42rem;
        width: .42rem;
        height: .42rem;
    }
    .alert-pay .cont{
        max-height: 6rem;
        padding: 0 .8rem .72rem .72rem;
        color: #fff;
        font-size: .48rem;
        overflow: auto;
    }
    .alert-pay{
        background: #1a243f;
    }
    .alert-pay .alert-head{
        padding: .5rem .4rem;
        font-size: .48rem;
        border-bottom: 1px solid #858585;
    }
    .alert-pay .alert-btn{
        padding: .3rem 0;
        color: #2CAADE;
        font-size: .42rem;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/duihuang.vue